import { BookOpenIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
    value: '59,90€',
    today: 'Hoy: Incluido',
    lead: 'Sesiones profesionales listas para que nunca te falten ejercicios.',
    items: [
      'TOMO I — El ADN del Jugador (Fundamentos Individuales): Desde el agarre y ciclo de pasos hasta la biomecánica del lanzamiento. Cada gesto técnico desmenuzado para que entiendas el porqué de lo que corriges. Base sólida sobre la que construir el balonmano de tu equipo.',
      'TOMO II — La Pizarra Dinámica (Táctica Grupal y Sistemas): El paso del 2x2 al sistema defensivo 6:0 y 5:1. Cómo construir defensa, cómo leer ataque, cómo hacer que tu equipo entienda el juego colectivo más allá de ejecutar órdenes. Sistemas probados en pista pequeña.',
      'TOMO III — Cronograma Maestro (Planificación Anual): La hoja de ruta de los 9 meses. Microciclos y macrociclos. Cómo estructurar una temporada sin estrés, cuándo intensificar, cuándo consolidar, cuándo competir. El calendario que sostiene todo lo demás.',
      'TOMO IV — Preparación Física Integrada: Cómo ganar potencia y velocidad usando el balón (sin gimnasio pesado). Desarrollo atlético que tiene sentido en pista. Salto, explosividad y resistencia específica de balonmano.',
      'TOMO V — La Mente del Guerrero (Psicología y Gestión de Grupo): Liderazgo distribuido, gestión de roles, resolución de conflictos en el vestuario. Cómo construir un equipo que se respeta, se comunica y crece mentalmente. Lo que no enseñan en cursos de técnica.',
      'TOMO VI — Análisis de Élite (Gestión de Partido): Cómo leer el juego del rival en tiempo real y reaccionar en el tiempo muerto. Estrategia ofensiva y defensiva adaptada. Decisiones que ganan partidos.'
    ]
  },
  {
    icon: DumbbellIcon,
    tag: 'Incluido 💪',
    title: 'Los 5 Bonos Estratégicos',
    value: '59,50€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — El Protocolo de Sesiones Críticas: Sesiones listas para cuando no tienes tiempo, faltan jugadores o necesitas resolver un entrenamiento difícil sin improvisar. 10 protocolos prácticos (sesión con pocos jugadores, sin portero, prepartido, post-derrota, etc.) listos para copiar y llevar a pista.',
      'Bono #2 — Arquitectura de Salud: Reducción del Riesgo en Pista: Una guía práctica para entrenar con más criterio, detectar señales de alerta y construir hábitos preventivos. Calentamiento estructurado, observación de técnica, protocolo prudente ante molestias.',
      'Bono #3 — El Entrenador Diplomático: Scripts, mensajes y protocolos para gestionar padres, directiva y entorno sin perder autoridad ni desgastarte. Guion de reunión inicial, WhatsApp profesional, gestión de quejas por minutos, comunicación con familias.',
      'Bono #4 — Ingeniería del Scouting Low-Cost: Aprende a analizar rivales con una libreta, un móvil y criterios claros, sin software caro. Ficha de scouting, qué observar del ataque, defensa, transiciones. Cómo convertir observación en plan de partido aplicable.',
      'Bono #5 — Sistemas de Métrica y Evolución 360: Plantillas simples para medir evolución técnica, táctica y grupal sin perderte en estadísticas imposibles. Fichas individuales, trackers de asistencia, registro de objetivos, evaluación continua.'
    ]
  }
];
